import cookies, {VALUE_TRACK_KEY} from '../../helpers/cookies'
import {ValueTrack} from '../../hooks/useValueTrackSaver'

const getValueTrack = (): ValueTrack[] | null => {
    try {
        const existingValueTrack = cookies.get(VALUE_TRACK_KEY)
        if (existingValueTrack) {
            const parsedExistingValueTrack = JSON.parse(existingValueTrack)
            if (Array.isArray(parsedExistingValueTrack)) {
                return parsedExistingValueTrack
            }
            return null
        }
    } catch (e) {
        console.error(e)
    }
    return null
}

export default getValueTrack
